// eslint-disable-next-line no-unused-vars
const middlewarePageTitle = async ({ to, from }) => {
  document.title = `富邦槓桿交易商會員系統${
    to.meta?.title ? ` - ${to.meta.title}` : ''
  }`
  return true
}

export { middlewarePageTitle }
